import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "saving-overlay"
}
const _hoisted_2 = {
  class: "card",
  style: {"max-width":"800px"}
}
const _hoisted_3 = {
  class: "grid",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(220px, 1fr))","gap":"14px"}
}
const _hoisted_4 = { class: "input-field" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "input-field" }
const _hoisted_7 = { class: "input-field" }
const _hoisted_8 = { class: "section" }
const _hoisted_9 = { class: "section-header" }
const _hoisted_10 = {
  class: "grid",
  style: {"gap":"10px"}
}
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "hint"
}
const _hoisted_13 = {
  key: 1,
  class: "grid",
  style: {"gap":"10px"}
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 2,
  class: "grid",
  style: {"gap":"10px"}
}
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "subtitle",
  style: {"color":"#a54b2a"}
}
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoticeModal = _resolveComponent("NoticeModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page", { embedded: _ctx.embedded }])
  }, [
    (_ctx.isSaving)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("div", { class: "saving-card" }, "Salvando dados...", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("div", null, [
          _createElementVNode("h1", { class: "title" }, "Dialogos de Seguranca"),
          _createElementVNode("p", { class: "subtitle" }, "Registro do dialogo com a equipe.")
        ]),
        _createElementVNode("span", { class: "pill" }, "Seguranca")
      ], -1)),
      _createElementVNode("form", {
        class: "form-grid",
        onSubmit: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "attraction" }, "Projeto", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "attraction",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.attraction) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectOptions, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.attraction]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[15] || (_cache[15] = _createElementVNode("label", { for: "theme" }, "Tema do dialogo", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "theme",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.theme) = $event)),
              type: "text",
              placeholder: "Tema principal"
            }, null, 512), [
              [_vModelText, _ctx.theme]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "reportDate" }, "Data", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "reportDate",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reportDate) = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, _ctx.reportDate]
            ])
          ])
        ]),
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "section-title" }, "Participantes", -1)),
            _createElementVNode("button", {
              class: "btn btn-ghost",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addSelectedParticipant && _ctx.addSelectedParticipant(...args)))
            }, "Adicionar selecionado")
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedParticipant) = $event))
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "Selecione um subordinado/colaborador", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participantOptions, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: option.username,
                  value: option.username
                }, _toDisplayString(option.name) + " (" + _toDisplayString(option.username) + ") ", 9, _hoisted_11))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedParticipant]
            ])
          ]),
          (_ctx.participants.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Nenhum participante adicionado."))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.participants, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `p-${index}`,
                    class: "list-row"
                  }, [
                    _createElementVNode("div", null, _toDisplayString(_ctx.participantLabel(item)), 1),
                    _createElementVNode("button", {
                      class: "btn btn-accent",
                      type: "button",
                      onClick: ($event: any) => (_ctx.removeParticipant(index))
                    }, "Excluir", 8, _hoisted_14)
                  ]))
                }), 128))
              ])),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showLegacyMethod = !_ctx.showLegacyMethod))
          }, _toDisplayString(_ctx.showLegacyMethod ? 'Ocultar metodo de texto' : 'Usar metodo alternativo (texto)'), 1),
          (_ctx.showLegacyMethod)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legacyParticipants, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `legacy-${index}`,
                    class: "list-row"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.legacyParticipants[index]) = $event),
                      type: "text",
                      placeholder: "Nome escrito manualmente"
                    }, null, 8, _hoisted_16), [
                      [_vModelText, _ctx.legacyParticipants[index]]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-accent",
                      type: "button",
                      onClick: ($event: any) => (_ctx.removeLegacyParticipant(index))
                    }, "Excluir", 8, _hoisted_17)
                  ]))
                }), 128)),
                _createElementVNode("button", {
                  class: "btn btn-ghost",
                  type: "button",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addLegacyParticipant && _ctx.addLegacyParticipant(...args)))
                }, "Adicionar nome manual")
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "btn btn-secondary",
            type: "button",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args))),
            disabled: _ctx.isSaving
          }, " Salvar rascunho ", 8, _hoisted_20),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args))),
            disabled: _ctx.isSaving
          }, " Enviar ", 8, _hoisted_21),
          (_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-accent",
                type: "button",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args))),
                disabled: _ctx.isSaving
              }, " Excluir ", 8, _hoisted_22))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-ghost",
            type: "button",
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
            disabled: _ctx.isSaving
          }, " Cancelar ", 8, _hoisted_23)
        ])
      ], 32)
    ]),
    _createVNode(_component_NoticeModal, {
      open: _ctx.noticeOpen,
      title: _ctx.noticeMessage,
      "button-text": "Entendi",
      onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.noticeOpen = false))
    }, null, 8, ["open", "title"])
  ], 2))
}